<template>
  <online-search-select
    :searchFunction="onlineSearchCompanies"
    :labelProvider="labelProvider"
    v-model="companyProxy"
    placeholder="поиск компании"
    bg="dark"
    class="w-100"
  />
</template>

<script>
import OnlineSearchSelect from '@/components/ui/OnlineSearchSelect.vue'
import { DataService } from '@/services/DataService.js'

export default {
  props: ['field'],
  components: {
    OnlineSearchSelect
  },
  watch: {
    value: {
      immediate: true,
      handler: function (companyId) {
        if (companyId) {
          this.searchPersistedCompany(companyId)
        } else {
          this.company = null
        }
      }
    }
  },
  computed: {
    value () {
      return this.field.value
    },
    companyProxy: {
      get () {
        return this.company
      },
      set (company) {
        this.company = company
        this.$emit('input', { value: (company ? company.id : null), debounced: false })
      }
    }
  },
  data () {
    return {
      company: null,
      searchPersistedCompany: async (companyId) => {
        this.$emit('editing', true)
        const params = { filter: { id: companyId }, offset: 0, limit: 1 }
        return DataService.getCompanies(params)
          .then(({ data: { company: { data, totalCount } } }) => {
            this.company = data ? data.map(c => ({ id: c.id, name: c.title })).pop() : null
          })
          .finally(() => { this.$emit('editing', false) })
      },
      onlineSearchCompanies: async (title) => {
        const params = { filter: { title: title }, offset: 0, limit: 50 }
        return DataService.getCompanies(params)
          .then(({ data: { company: { data, totalCount } } }) => {
            return {
              items: data ? data.map(c => ({ id: c.id, name: c.title })) : []
            }
          })
      },
      labelProvider: function (item) {
        return item ? `ИНН: ${item.id}: ${item.name}` : item
      }
    }
  }
}
</script>
